import AOS from "aos";
import "aos/dist/aos.css";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router";
import { toast } from "react-toastify";
import api, { shareUrl } from "../../../../../../api/api";
import {
  Course_created_successfully_image,
  StudentViewCourseDetails_assignments_icon,
  course_bg_image,
  course_demo_image,
  social_image,
} from "../../../../../../assets/images/images";
import {
  setDrawerState,
  setIsWebAllowed,
  setQueryMetaData,
  setAgentData,
  setInitialProjectId,
} from "../../../../../../state/reducers/chatDrawerReducers";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import { updateGlobalState } from "../../../../../../state/global/slice";
import { AssignmentType } from "../../../../../../utils/consts";
import { changeScrollPopup, toTitleCase, hasFreeDomainAccess } from "../../../../../../utils/utlis";
import DescriptionCoursePopup from "../../teacher/course/DescriptionCoursePopup";
import FilteredInput from "../../../../../../components/FilteredInput/FilteredInput";
import { Ring } from "@uiball/loaders";
import { addCourseToCart } from "../../../../../../state/actions/addtoCartAction";
import BackButton from "../../../../../../components/BackButton/BackButton";
import LessonCard from "../lessons/LessonCard";
import { CircularProgress, Grid, Pagination } from "@mui/material";
import lessonGif from "../../../../../../assets/images/lessonGIF.gif";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton";

// How long to wait between re-polls when any lesson is still generating (ms)
const GENERATION_POLL_INTERVAL_MS = 60_000; // 1 minute

const StudentViewCourseDetails = (props) => {
  const [searchParams] = useSearchParams();
  const from = searchParams.get("from");

  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { token } = useAuth();
  const dispatch = useDispatch();
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cancelstatus, setCancelstatus] = useState(false);
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const globalState = useSelector((state) => state.globalState);
  const profileDetails = useSelector((state) => state.profileDetails);
  const isMarketplace = globalState?.enabled_modules?.includes('marketplace');
  const currency_symbol = useSelector((state) => state.globalState?.currency_symbol);
  const isStudent = globalState.role === "Student";
  const isFromInvite =
    location?.state?.isFromInvite ?? props?.isFromInvite ?? true;
  const [course, setCourse] = useState(
    location?.state?.course ?? props?.course ?? {}
  );
  const [showreuestsuccesfully, setshowreuestsuccesfully] = useState(false);
  const [getcoursestatus, setCoursestatus] = useState(course?.status ?? "");
  const [OpenPopup, setOpenPopup] = useState(false);
  const [item_id, setitem_id] = useState(null);
  const [inCart, setInCart] = useState(course?.in_cart);

  // A student whose email domain is whitelisted on the course gets it free,
  // so they take the enroll/request flow rather than the cart flow.
  const isFreeForStudent = hasFreeDomainAccess(
    course,
    globalState?.email || globalState?.student_details?.data?.email,
  );

  const coursePrice = course?.discount_price ?? course?.price;
  const isPaidCourse = coursePrice != null && Number(coursePrice) > 0;
  const showCartFlow = isMarketplace && isPaidCourse && !isFreeForStudent;
  const [lessonLoading, setlessonLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const itemsPerPage = 12;
  const [currentPage, setCurrentPage] = useState(1);
  const courseId = course?.course_id;
  const inial_value = (currentPage - 1) * itemsPerPage;
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);

  // ── Polling refs ────────────────────────────────────────────────
  // pollingTimerRef: holds the setTimeout ID so we can cancel it on unmount
  // pollingParamsRef: avoids stale-closure captures of course_id / page
  const pollingTimerRef = useRef(null);
  const pollingParamsRef = useRef({ course_id: null, page: 1 });

  // Cancel any pending poll when the component unmounts or course id changes
  useEffect(() => {
    return () => {
      if (pollingTimerRef.current) {
        clearTimeout(pollingTimerRef.current);
        pollingTimerRef.current = null;
      }
    };
  }, [id]);

  const handleBack = () => {
    navigate("/dashboard/home");
  };

  useEffect(() => {
    fetchCourse(id);
  }, [id]);

  useEffect(() => {
    if (!profileDetails.isLoading && profileDetails.error !== null) {
      navigate('/');
      localStorage.setItem("redirectToCourse", location.pathname);
    }
  }, [profileDetails]);

  const getDecryptCourseId = async (encrypted_id) => {
    const decrypted_id = await api
      .get(`courses/course-invite/?id=${encrypted_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((res) => res?.data?.course_id)
      .catch(() => null);
    if (!decrypted_id) return;
    await fetchCourse(decrypted_id);
  };

  const fetchCourse = async (id) => {
    if (!token) return;
    const getCourse = await api
      .get(`courses/get-course/${id}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((res) => res?.data?.data)
      .catch(() => null);

    if (!getCourse) return;
    setCourse(getCourse);
    setCoursestatus(getCourse?.status ?? "");
    setInCart(getCourse?.in_cart ?? false);
    fetchLessons(getCourse?.course_id, 1);
  };

  const [lessons, setlessondetails] = useState(null);

  const fetchLessons = (course_id, page, isPolling = false) => {
    if (!token || !course_id) return;

    // Cancel any in-flight poll timer before starting a new fetch
    if (pollingTimerRef.current) {
      clearTimeout(pollingTimerRef.current);
      pollingTimerRef.current = null;
    }

    // Keep params fresh for the poll callback (avoids stale closure)
    pollingParamsRef.current = { course_id, page };

    // Only show the loader immediately for non-poll (initial / page-change)
    // fetches. For background polls the existing lesson list stays visible
    // until the response decides whether generation is still in progress.
    if (!isPolling) {
      setlessonLoading(true);
    }

    api
      .get(`lessons/get-all-lessons/course/${course_id}/`, {
        params: { page },
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          const fetchedLessons = response?.data?.data ?? [];
          setlessondetails(fetchedLessons);
          setTotalPages(
            response.data.count >= 12
              ? Math.ceil(response.data.count / itemsPerPage)
              : Math.floor(response.data.count / itemsPerPage)
          );
          setNextUrl(response.data.next);
          setPrevUrl(response.data.previous);

          // The GIF should stay visible only when the free lesson is still
          // being generated — not for background non-free lessons.
          const freeLesson = fetchedLessons.find((lesson) => lesson?.free_lesson === true);
          const isFreeLessonGenerating = freeLesson !== null && freeLesson?.complete_generation === false;
          setlessonLoading(isFreeLessonGenerating);

          // Schedule re-poll if any lesson (free or paid) is still generating.
          // The next poll will re-evaluate isFreeLessonGenerating and either
          // keep the GIF up or flip lessonLoading to false when done.
          const anyStillGenerating = fetchedLessons.some(
            (lesson) => lesson?.complete_generation === false
          );

          if (anyStillGenerating) {
            pollingTimerRef.current = setTimeout(() => {
              const { course_id: cid, page: pg } = pollingParamsRef.current;
              fetchLessons(cid, pg, true); // isPolling = true — no upfront loader flash
            }, GENERATION_POLL_INTERVAL_MS);
          } else {
            pollingTimerRef.current = null;
          }
        }
      })
      .catch(() => {
        setlessondetails([]);
        setlessonLoading(false);
      });
  };

  const [selLession, setSelLession] = useState(-1);

  const onExpand = (i) => {
    setSelLession(selLession === i ? -1 : i);
  };

  const courseRequested = async (id) => {
    if (course?.source && course?.source === "Requested") {
      toast.error("You have already requested enrollment for this course");
      return;
    }
    const formData = new FormData();
    formData.append("course", id);
    formData.append("enrolled_on", new Date().toISOString().slice(0, 10));
    const url = "courses/student/enroll-course/";
    const headers = { Authorization: `Token ${token}` };

    try {
      setIsLoading(true);
      const enrollResponse = await api.post(url, formData, { headers });
      if (enrollResponse.data.status !== 200) throw new Error("Enrollment request failed");

      setshowreuestsuccesfully(true);
      await new Promise((resolve) => setTimeout(resolve, 1500));

      const coursesResponse = await api.get("/courses/student/my-courses-dashboard/", {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Token ${token}` },
      });
      if (coursesResponse.status === 200) {
        updateState("student_courses", coursesResponse?.data?.data ?? []);
        setCoursestatus("Pending");
        setIsEnrolled(true);
      }
      setshowreuestsuccesfully(false);
    } catch (error) {
      toast.error("Failed to enroll in course");
      setshowreuestsuccesfully(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getShareLink = ({ platform, course, baseURL }) => {
    let shareUrl = "";
    baseURL = `${baseURL}`;

    const courseDescription =
      course?.description?.length > 100
        ? course?.description
        : course?.description;
    const data = `Hi! You're invited to enroll in the new course, ${course?.name} by ${course?.title} ${course?.teacher}. Check it out here:`;
    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(baseURL)}&quote=${encodeURIComponent(data)}`;
        break;
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(data)} ${encodeURIComponent(baseURL)}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(data)} ${encodeURIComponent(baseURL)}`;
        break;
      case "instagram":
        shareUrl = `https://www.instagram.com/?url=${encodeURIComponent(baseURL)}`;
        break;
      default:
        shareUrl = baseURL;
        return;
    }
    return shareUrl;
  };

  const getPlatform = {
    FACEBOOK: "facebook",
    WHATSAPP: "whatsapp",
    TWITTER: "twitter",
    INSTAGRAM: "instagram",
    SHARE: "share",
  };

  const [sharelink, setSharelink] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleDropdown = () => {
    onShare(getPlatform.SHARE, false);
    setShowDropdown(!showDropdown);
    changeScrollPopup("auto", "view-course-details-share-form");
  };

  const [linkBaseUrl, setLinkBaseUrl] = useState("");

  const onShare = async (platform, isOpenNewWindow = true) => {
    setLoading(true);
    setLoading(false);
    if (isOpenNewWindow) toggleDropdown();
    const getURL = `${shareUrl}course/${course?.course_id}/view`;
    const getShareableLink = getShareLink({ platform, course, baseURL: getURL });
    setLinkBaseUrl(getURL);
    setSharelink(getShareableLink);
    if (isOpenNewWindow) window.open(getShareableLink, "_blank");
  };

  const onClickCopy = () => {
    toggleDropdown();
    const redirectPath = `course/${course.course_id}/view`;
    const fullUrl = `${shareUrl}${shareUrl.endsWith("/") ? "" : "/"}${redirectPath}`;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(fullUrl)
          .then(() => toast.success("Copied to clipboard", { position: "top-center" }))
          .catch(() => toast.error("Failed to copy text", { position: "top-center" }));
      } else {
        document.execCommand("copy");
        toast.success("Copied to clipboard", { position: "top-center" });
      }
    } catch (error) {
      toast.error("Failed to copy text", { position: "top-center" });
    }
  };

  useEffect(() => {
    onShare(getPlatform.SHARE, false);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);

  const cancelrequest = (courseid) => {
    const url = `courses/cancel-enrollment-request/${courseid}/`;
    const headers = { Authorization: `Token ${token}` };
    api
      .delete(url, { headers })
      .then((response) => {
        if (response.data.status === 200) {
          setCancelstatus(true);
          setshowreuestsuccesfully(true);
          setTimeout(() => {
            setshowreuestsuccesfully(false);
            setOpenDialog(false);
            setCancelstatus(false);
            setCoursestatus(null);
            setIsEnrolled(false);
            // navigate("/dashboard/home");
          }, 2000);
        }
      })
      .catch(() => {});
  };

  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);
  const paragraphRef = useRef(null);

  const descriptionToggle = () => setDescriptionOpen(!descriptionOpen);

  const addToCart = (itemId) => {
    setitem_id(itemId);
    setInCart(true);
    dispatch(addCourseToCart(itemId, token));
  };

  const onCancel = () => setOpenPopup(false);

  const onConfirm = (item_id) => {
    setitem_id(item_id);
    setInCart(true);
    setOpenPopup(false);
    dispatch(addCourseToCart(item_id, token));
  };

  useEffect(() => {
    const descriptionLength = course?.description?.length || 0;
    if (paragraphRef.current) {
      const lineHeight = parseFloat(window.getComputedStyle(paragraphRef.current).lineHeight);
      const height = paragraphRef.current.clientHeight;
      const lineCount = height / lineHeight;
      setShowViewMore(lineCount > 5 || descriptionLength > 300);
    }
  }, [course?.description]);

  const [openDialog, setOpenDialog] = useState(false);

  const handleCancelClick = () => setOpenDialog(true);

  const cancelRegistration = () => {
    setOpenDialog(false);
    document.body.style.overflow = "auto";
  };

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
    // Cancel existing poll and re-fetch the new page
    if (pollingTimerRef.current) {
      clearTimeout(pollingTimerRef.current);
      pollingTimerRef.current = null;
    }
    fetchLessons(courseId, value);
  };

  return (
    <>
      <div className="dashboard" id="StudentViewCourseDetails-section">
        <div className="view-course-Details-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                {from === "cart" ? (
                  <div
                    className="view-course-Details-back-btn-folder"
                    onClick={() => navigate("/dashboard/home", { state: { course } })}
                  >
                    <i className="fa-solid fa-chevron-left"></i>
                    <h2>Back</h2>
                  </div>
                ) :  (
                  <div className="view-course-Details-back-btn-folder">
                    {location.state === "after submission" ? (
                      <BackButton buttonName="Back" onClick = {() => navigate("/")} />
                    ) : (
                      <BackButton buttonName="Back" goBack={true} />
                    )}
                  </div>
                )}

                <div className="studentDashboar-profile-btn-folder">
                  <div className="view-course-details-edit-and-share-container">
                    <div
                      onClick={toggleDropdown}
                      className="view-course-details-edit-and-share-folder view-course-details-share-btn"
                      id="student-share-btn"
                    >
                      <span href="#">
                        <i className="fa-solid fa-share-nodes"></i>
                      </span>
                      <p>Share</p>
                    </div>
                  </div>

                  {/* {isMarketplace &&
                    (course.discount_price || course.price) != null ||
                  (course.discount_price || course.price) > 0 ? ( */}
                  {showCartFlow ? (
                    <>
                      {inCart ? (
                        <button
                          className="enroll_now_btn"
                          type="button"
                          onClick={() => navigate('/cart')}
                        >
                          Go To Cart
                        </button>
                      ) : (
                        <button
                          className="enroll_now_btn"
                          type="button"
                          onClick={() => addToCart(course?.course_id)}
                        >
                          <i className="fa-solid fa-cart-shopping" style={{ marginRight: "6px" }}></i>
                          Add To Cart
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      {getcoursestatus === "" ||
                      getcoursestatus == null ||
                      getcoursestatus === "Rejected" ||
                      getcoursestatus === "Visited" ? (
                        <>
                          {isLoading ? (
                            <Ring />
                          ) : (
                            <button
                              className="enroll_now_btn"
                              type="button"
                              style={{ fontSize: 16 }}
                              onClick={() => courseRequested(course?.course_id)}
                              disabled={isEnrolled || isLoading}
                            >
                              {isEnrolled ? "Request sent" : "Enroll"}
                            </button>
                          )}
                        </>
                      ) : (
                        <button
                          className="enroll_now_btn"
                          style={{ fontSize: 16 }}
                          type="button"
                          disabled="true"
                        >
                          {getcoursestatus === "Pending" ? "Request sent" : getcoursestatus}
                        </button>
                      )}
                      {getcoursestatus === "Pending" && (
                        <button
                          className="enroll_now_btn"
                          type="button"
                          style={{ fontSize: 14 }}
                          onClick={handleCancelClick}
                        >
                          Cancel Request
                        </button>
                      )}
                    </>
                  )}
                </div>

                {openDialog && (
                  <div className="Course-created-successfully-main">
                    <div className="Course-created-successfully-container">
                      <div className="Course-created-successfully-folder">
                        <h2>Are you sure you want to cancel the request?</h2>
                        <div className="Course-close-btn">
                          <button type="submit" onClick={cancelRegistration}>No</button>
                          <button
                            type="submit"
                            onClick={() => cancelrequest(course?.course_id)}
                            className="Course-close"
                          >
                            Yes
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="view-course-details-container">
                  <div className="view-course-details-folder student-view-course-Detaails-folder">
                    <div className="view-course-details-left-section">
                      <div className="view-course-details-image">
                        <img src={course?.image || course_demo_image} alt="" />
                      </div>
                    </div>
                    <div className="view-course-details-right-section">
                      {isMarketplace && course?.subject && (
                        <h5 style={{ color: "#888888", fontSize: "14px", marginBottom: "4px" }}>
                          {typeof course.subject === 'string'
                            ? toTitleCase(course.subject)
                            : (course.subject ? toTitleCase(Object.values(course.subject)[0]) : '')}
                        </h5>
                      )}
                      <div className="studentDashboard-course-name-rating">
                        <h2 style={isMarketplace ? { marginBottom: "6px" } : undefined}>
                          {course?.name}
                        </h2>
                        {isMarketplace && (
                          <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                            <a><i className="fa-solid fa-star"></i></a>
                            <p className="rate">{course?.average_course_rating || "0"}</p>
                            <p className="number">({parseInt(course?.rating_count || 0)})</p>
                          </div>
                        )}
                      </div>
                      {isMarketplace &&
                        (course?.price != null ||
                          course?.discounted_price != null ||
                          course?.discount_price != null) && !isFreeForStudent && (
                          <div
                            className="Price-section"
                            style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}
                          >
                            <h5 style={{ margin: 0 }}>Price:</h5>
                            {(course?.discount_price ?? course?.discounted_price) !== course?.price &&
                              course?.price > 0 && (
                                <span style={{ textDecoration: "line-through", color: "#888888" }}>
                                  {currency_symbol ?? ""}{course?.price ?? 0}
                                </span>
                              )}
                            <span
                              className="course-price"
                              style={{ color: "#ee7139", fontSize: "20px", fontWeight: 600 }}
                            >
                              {currency_symbol ?? ""}{course?.discount_price ?? course?.discounted_price ?? 0}
                            </span>
                          </div>
                        )}
                      <div className="teacherviewcoursedetails-des-wrapper">
                        <p className="teacherviewcoursedetails-des" ref={paragraphRef}>
                          {course?.description}
                        </p>
                        {/* Outside the <p>: inside, the line clamp would clip it. */}
                        {showViewMore && (
                          <span className="view-more" onClick={descriptionToggle}>
                            View More
                          </span>
                        )}
                        {descriptionOpen && (
                          <DescriptionCoursePopup
                            title="My Course Description"
                            data={course?.description}
                            onClick={descriptionToggle}
                          />
                        )}
                      </div>
                      <div className="view-course-details-container lg:gap-[32px] justify-start">
                        <div className="view-Students-course-details-folder">
                          <span>Total Lessons</span>
                          <div className="view-Students-course-details-counts">
                            <p>{course?.total_lessons}</p>
                            <p>{course?.total_lessons > 1 ? "Lessons" : "Lesson"}</p>
                          </div>
                        </div>
                        <div className="view-Students-course-details-folder">
                          {isStudent ? (
                            <>
                              <span>Total Assignments</span>
                              <div className="view-Students-course-details-counts">
                                <p>{course.total_assignments}</p>
                                <p>{course.total_assignments > 1 ? "Assignments" : "Assignment"}</p>
                              </div>
                            </>
                          ) : (
                            <>
                              <span>Total Assignments</span>
                              <div className="view-Students-course-details-counts">
                                <p>{course.total_assignments}</p>
                                <p>{course.total_assignments > 1 ? "Assignments" : "Assignment"}</p>
                              </div>
                              <span>Students Enrolled</span>
                              <div className="view-Students-course-details-counts">
                                <p>{course?.enrolled_students}</p>
                                <p>{course?.enrolled_students > 1 ? "Students" : "Student"}</p>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="view-Students-course-details-folder">
                          <span>Course Start Date</span>
                          <div className="view-Students-course-details-counts">
                            <p>{dayjs(course?.start_date).format("MMM DD, YYYY")}</p>
                          </div>
                        </div>
                        <div className="view-Students-course-details-folder">
                          <span>Course Expiry Date:</span>
                          <div className="view-Students-course-details-counts">
                            <p>
                              {course?.end_date !== null && course?.end_date !== ""
                                ? dayjs(course?.end_date).format("MMM DD, YYYY")
                                : "- -"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {lessonLoading ? (
                  <div className="StudentViewCourseDetails-lesson-wrapper">
                    <div className="flex justify-center items-center w-full">
                      <img className="w-[20rem]" src={lessonGif} alt="Loading..." />
                    </div>
                  </div>
                ) : !lessons || lessons.length === 0 ? (
                  <div className="StudentViewCourseDetails-lesson-wrapper">
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                      <h4>No Lessons Available.</h4>
                    </div>
                  </div>
                ) : (
                  <div className="StudentViewCourseDetails-lesson-wrapper">
                    {isMarketplace ? (
                      lessons.map((lesson, index) => (
                        <LessonCard
                          key={lesson.lesson_id ?? index}
                          lesson={lesson}
                          index={index}
                          course={course}
                          courseId={courseId}
                          inial_value={inial_value}
                          lessons={lessons}
                        />
                      ))
                    ) : (
                      lessons.map((lesson, index) => (
                        <StudentViewCourseLesson
                          key={index}
                          id={index}
                          selLession={index === selLession}
                          lesson={lesson}
                          onExpand={() => onExpand(index)}
                        />
                      ))
                    )}
                    {isMarketplace && totalPages > 1 && (
                      <Grid xs={12} container justifyContent={"center"}>
                        <Pagination
                          count={totalPages}
                          page={currentPage}
                          onChange={handlePageChange}
                          color="primary"
                          hideNextButton={nextUrl === null || currentPage === totalPages}
                          hidePrevButton={prevUrl === null || currentPage === 1}
                        />
                      </Grid>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {showreuestsuccesfully && (
            <div className="Course-created-successfully-main">
              <div className="Course-created-successfully-container">
                <div className="Course-created-successfully-folder">
                  <div className="Course-created-successfully-image">
                    <img src={Course_created_successfully_image} alt="" />
                  </div>
                  <h2>
                    {cancelstatus
                      ? "Course request cancel successfully"
                      : "Course request sent successfully"}
                  </h2>
                </div>
              </div>
            </div>
          )}
        </div>

        {showDropdown && (
          <form className="view-course-details-share-form">
            <div className="view-course-details-share-folder" data-aos="zoom-in">
              <h2>Share Course</h2>
              <div className="view-course-details-inner-wrapper">
                <p>Share this link via</p>
                <div className="view-course-social-links-folder">
                  <div
                    onClick={() => onShare(getPlatform.WHATSAPP)}
                    className="view-course-social-links-image"
                  >
                    <img src={social_image} alt="" />
                  </div>
                </div>
                <p>Or copy link</p>
                <div className="copy-link-or-path-folder">
                  <input
                    type="text"
                    value={linkBaseUrl}
                    placeholder="example.com/share-link"
                    disabled
                    style={{ marginBottom: "20px" }}
                  />
                  <button type="button" onClick={onClickCopy}>Copy</button>
                </div>
                <i
                  onClick={toggleDropdown}
                  className="fa-solid fa-xmark shocial-cross-btn share-course-social-media-btn"
                ></i>
              </div>
            </div>
          </form>
        )}
      </div>
      {
        <FloatingAIButton
          onClick={() => {
            const agentData = [
              {
                key: course?.name || "Course",
                value: String(course?.course_id || ""),
              },
            ];

            dispatch(setAgentData(agentData));
            if (course?.course_id) {
              dispatch(setInitialProjectId(String(course?.course_id)));
            }
            dispatch(setDrawerState(!chatDrawerState.isOpen));
            dispatch(setIsWebAllowed(true));
            dispatch(setQueryMetaData(null));
          }}
        />
      }
    </>
  );
};

// ── StudentViewCourseLesson (non-marketplace branch, unchanged) ───
const StudentViewCourseLesson = (props) => {
  const getAssignmentTypeName = (type) => {
    return Object.values(AssignmentType).find((item) => item.value === type)?.name;
  };
  const [assignments, setAssignments] = useState([]);
  const { token } = useAuth();

  useEffect(() => {
    if (props.selLession) {
      setAssignments([]);
      api
        .get(`assignments/get-assignments-by-lesson/${props.lesson?.lesson_id}/`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setAssignments(response?.data?.data ?? []);
          }
        })
        .catch(() => setAssignments([]));
    }
  }, [props.selLession]);

  return (
    <div className="StudentViewCourseDetails-lesson-containner">
      <div className="StudentViewCourseDetails-lesson-folder">
        <div className="StudentViewCourseDetails-lesson-toggle-dropdown-section">
          <div className="StudentViewCourseDetails-lesson-toggle-btn">
            <span onClick={() => props.onExpand()}>
              {props.selLession ? (
                <i className="fa-solid fa-arrow-down"></i>
              ) : (
                <i className="fa-solid fa-arrow-right"></i>
              )}
            </span>
            <h2>Lesson 0{props?.id + 1}</h2>
          </div>
          <span className="StudentViewCourseDetails-lesson-des">{props.lesson?.name}</span>
          <div className="StudentViewCourseDetails-lesson-assignments-tab">
            <p>
              <div className="StudentViewCourseDetails-assignments0-icon">
                <img src={StudentViewCourseDetails_assignments_icon} alt="" />
              </div>
              <span className="StudentViewCourseDetails-assignments-count">
                {props?.lesson?.assignment_count && props?.lesson?.assignment_count > 0
                  ? `${props?.lesson?.assignment_count} assignment`
                  : "No assignments"}
              </span>
            </p>
          </div>
        </div>
        {props.selLession && (
          <div className="StudentViewCourseDetails-lesson-inner-assignments-container">
            <h2>{props.lesson?.name}</h2>
            <div className="StudentViewCourseDetails-lesson-inner-assignments-wrapper">
              {assignments.map((assignment, index) => (
                <div key={index} className="StudentViewCourseDetails-lesson-inner-assignments-folder">
                  <h2>
                    Assignment <span>{index > 9 ? index : "0" + (index + 1)}</span>:{" "}
                    <span>{assignment?.name}</span>
                  </h2>
                  <h2>{getAssignmentTypeName(assignment?.type)}</h2>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentViewCourseDetails;